import { LineItem } from '@commercetools/platform-sdk';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import productReviewsService from '../../../services/productReviews';
import {
  getProductReviewRatingsQueryString,
  parseProductReviewRatingsResponse,
} from '../../../utils/productReviews';

const getProductReviewRatingsQueryKey = (lineItems: LineItem[] = []): string =>
  lineItems
    .map((lineItem: LineItem): string | undefined => lineItem.productKey)
    .filter(Boolean)
    .sort()
    .join(',');

const useGetProductReviewRatings = (
  lineItems: LineItem[] = [],
): UseQueryResult<Record<string, string>> =>
  useQuery({
    queryKey: [
      'useGetProductReviewRatings',
      getProductReviewRatingsQueryKey(lineItems),
    ],
    enabled: lineItems.some(
      (lineItem: LineItem): boolean => !!lineItem.productKey,
    ),
    queryFn: async (): Promise<Record<string, string>> => {
      const productReviewRatingsQuery: string =
        getProductReviewRatingsQueryString(lineItems);

      const productReviewRatingsResponse =
        await productReviewsService.getProductReviewRatings(
          productReviewRatingsQuery,
        );

      return parseProductReviewRatingsResponse(productReviewRatingsResponse);
    },
  });

export default useGetProductReviewRatings;
